
const Kumelenme = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Clusters</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>To enhance collaboration among Türkiye’s leading companies, strategic clusters are being established—primarily in Security, Smart Cities, Traffic Management, and Information and Communication Technologies (ICT)—alongside various cooperation development initiatives.</p>
          <p>Within the scope of clustering programs supported by public initiatives, the primary objectives include:</p>
        </div>
      </div>

      <div className="row justify-content-md-center">
        <div className="col-10">
          <ul>
            <li>Advancing internationalization and global market presence.</li>
            <li>Strengthening intra-cluster and inter-cluster cooperation. * Enhancing sectoral know-how and cross-sectoral expertise transfer to ensure resource efficiency.</li>
            <li>Facilitating the effective planning of new investments.</li>
          </ul>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>The Managing Company organizes both complimentary and fee-based conferences, seminars, and workshops tailored to the evolving training needs of company employees.</p>
          <p>To foster international collaboration and domestic synergy, the Managing Company implements various projects, including brokerage events (project markets), sectoral trade delegations, B2B matchmaking, and buyer delegations, as well as coordinated participation in international trade fairs.</p>
          <p>Furthermore, coordination activities are conducted between resident and non-resident companies, universities, and R&D institutions to develop technological solutions for technical challenges encountered during project implementation.</p>
        </div>
      </div>
    </>
  );
};

export default Kumelenme;
